import { COMPANY } from "../data";
import { ArrowUpRight } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[var(--blue)] text-white">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 pt-20 md:pt-28 pb-10">
        <div className="grid md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-6">
            <img
              src="/dopman-logo.png"
              alt="DOPMAN B.V."
              className="h-12 w-auto mb-6 brightness-0 invert opacity-95"
            />
            <p className="font-mono-tech text-xs uppercase tracking-[0.25em] text-white/50 mb-4">Voor ieder opdracht, de juiste vakman</p>
            <a href="#contact" className="font-display text-3xl md:text-4xl font-medium tracking-tight inline-flex items-center gap-3 hover:text-[var(--turq)] transition-colors" data-testid="footer-cta">
              Laten we samen bouwen <ArrowUpRight className="text-[var(--turq)]" />
            </a>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-white/40 mb-4">Contact</p>
            <ul className="space-y-2 text-white/80">
              <li><a href={`mailto:${COMPANY.email}`} className="hover:text-[var(--turq)] transition-colors">{COMPANY.email}</a></li>
              <li><a href={COMPANY.phoneHref} className="hover:text-[var(--turq)] transition-colors">{COMPANY.phone}</a></li>
              <li className="text-white/60">{COMPANY.address}</li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-white/40 mb-4">Bedrijfsgegevens</p>
            <ul className="space-y-2 text-white/80">
              <li>{COMPANY.legal}</li>
              <li>KVK: {COMPANY.kvk}</li>
              <li>BTW: {COMPANY.btw}</li>
              <li className="text-white/60">Opgericht in {COMPANY.since}</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/15 pt-10">
          <div className="font-display text-[19vw] md:text-[15vw] leading-[0.8] font-semibold tracking-tighter text-white/95 select-none">
            DOPMAN
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mt-10 text-white/40 text-sm">
          <span>© {new Date().getFullYear()} {COMPANY.legal}. Alle rechten voorbehouden.</span>
          <span className="font-mono-tech text-[10px] uppercase tracking-[0.2em]">Bouwbedrijf · Voorschoten · NL</span>
        </div>
      </div>
    </footer>
  );
};
